'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.historyMessageInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _PubNubMessageRecord = require('conversations-schema/pubnub-message/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _CommonMessage = require('conversations-schema/common-message-format/records/CommonMessage');

var _CommonMessage2 = _interopRequireDefault(_CommonMessage);

var _ActivelyPublishing = require('conversations-schema/unpublished-messages/records/ActivelyPublishing');

var _ActivelyPublishing2 = _interopRequireDefault(_ActivelyPublishing);

var _FailedToPublish = require('conversations-schema/unpublished-messages/records/FailedToPublish');

var _FailedToPublish2 = _interopRequireDefault(_FailedToPublish);

var _ContextUpdateMessage = require('conversations-schema/context-update/records/ContextUpdateMessage');

var _ContextUpdateMessage2 = _interopRequireDefault(_ContextUpdateMessage);

var _InitialMessage = require('conversations-schema/initial-message/records/InitialMessage');

var _InitialMessage2 = _interopRequireDefault(_InitialMessage);

var _getRecordName = require('conversations-schema/lib/getRecordName');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validRecordTypes = [_PubNubMessageRecord2.default, _CommonMessage2.default, _ContextUpdateMessage2.default, _ActivelyPublishing2.default, _FailedToPublish2.default, _InitialMessage2.default];

var historyMessageInvariant = exports.historyMessageInvariant = function historyMessageInvariant(message) {
  return (0, _invariant2.default)(validRecordTypes.some(function (type) {
    return message instanceof type;
  }), 'Expected message to be one of ' + validRecordTypes.map(function (record) {
    return (0, _getRecordName.getRecordName)(record);
  }).join(', ') + ', not a %s', typeof message === 'undefined' ? 'undefined' : _typeof(message));
};